export const DEFAULT_LAUNCH_DARKLY_FLAGS = {
  ChatPlusCalendar: false,
  erin_test_flag_react: false,
  MultiCalScheduling: false,
  NudgesAutoOpen: false,
  Q12023OnboardingFlexMeetingCalculation: false,
  ShowChatDebugInfo: false,
  CustomJoinAPlanRequest: false,
  "2023Q3LicenseManagement": false,
  ClockwiseAI: false,
  ClockwiseAIMini: false,
  EnableZendeskWebWidget: false,
  M365TeamAvailabilityCalendar: false,
  EnableWelcomePageCanonicalTag: false,
  LinkSettings: false,
  MultiCalendar: true,
  LinksVoCPolish: false,
  GatewayMonetization: false,
  GatewayPersonalizedStats: false,
  BrowserNotifications: false,
  AIEventSearch: false,
  PaywallExclusion: false,
  AIChatNUX: false,
  LinksCustomHours: false,
  LinksMaxBookingsPerDayOrWeek: false,
  OnDemandConflictResolution: false,
  LinksSharedSettings: false,
  LinksPackagingV2: false,
  PlannerMini: false,
  SlackDogfoodApp: false,
  RoundRobinScheduling: false,
  M365GALaunch: false,
  LinksFakeSignIn: false,
  ShareableProposals: false,
  OnboardingLinksSlide: false,
  GatewayCalendar: false,
  MaxTeamSizeOverride: 50,
  EnableHelpScoutBeacon: false,
  "rollout-sidebar-quick-rescheduling": false,
  "rollout-proposal-thread-tooltip": false,
} as const;

export type LaunchDarklyNameType = keyof typeof DEFAULT_LAUNCH_DARKLY_FLAGS;
export type LaunchDarklyMappingType = {
  [key in LaunchDarklyNameType]: boolean | number;
};
